<template>
  <v-container class="pt-0 pt-sm-3 px-sm-3" fluid>
    <Title
      v-if="$vuetify.breakpoint.smAndUp"
      :src="'departments'"
      :text="'All Departments'"
      textCentered
    />
    <v-row no-gutters>
      <v-col
        v-for="department in departments"
        :key="department.category_id"
        class="px-sm-3 pb-3 pb-sm-6 px-0 py-0"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <div class="background-color-white overflow-hidden pb-sm-5">
          <router-link :to="routeToDepartment(department)">
            <div
              class="d-flex justify-space-between mt-3 pl-5 pl-sm-2 pl-md-5 pl-xl-2 position-relative"
            >
              <div class="align-start d-flex">
                <Icon
                  :name="
                    formatToFileName(
                      getDepartmentDisplayName(department.category_id),
                    )
                  "
                  :color="$vuetify.theme.themes.light.primary"
                  :title="getDepartmentDisplayName(department.category_id)"
                  :style="{ height: '32', width: '32' }"
                ></Icon>
                <h3 class="ml-1 department-name">
                  {{ getDepartmentDisplayName(department.category_id) }}
                </h3>
              </div>
              <img
                v-if="
                  requireDepartmentPNGIcon(
                    getDepartmentDisplayName(department.category_id),
                  ) && $vuetify.breakpoint.smAndUp
                "
                class="department-image-size department-image-position"
                :alt="department.name"
                :src="
                  requireDepartmentPNGIcon(
                    getDepartmentDisplayName(department.category_id),
                  )
                "
                :srcset="`${requireDepartmentPNGIconSrcset(
                  getDepartmentDisplayName(department.category_id),
                )}`"
              />
              <router-link
                v-if="$vuetify.breakpoint.xsOnly"
                class="align-center d-flex font-size-sm"
                :to="routeToDepartment(department)"
              >
                View All
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </router-link>
            </div>
          </router-link>

          <div class="pr-5 pl-5 pl-sm-2 pl-md-5 pl-xl-2">
            <v-list :height="fixedListHeight">
              <v-list-item-group v-if="department.sub_categories">
                <router-link
                  v-for="category in sliceDepartmentCategories(
                    department.sub_categories,
                  )"
                  :to="routeToCategory(department, category)"
                  :key="category.category_id"
                >
                  <h4
                    class="color-black-magic font-weight-medium font-size-sm my-2"
                  >
                    {{ truncate(category.name, $vuetify.breakpoint.name) }}
                  </h4>
                </router-link>
              </v-list-item-group>
            </v-list>

            <router-link
              v-if="$vuetify.breakpoint.smAndUp"
              class="align-center d-flex font-size-sm"
              :to="routeToDepartment(department)"
            >
              View more
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { slug } from "github-slugger";
import { mapState, mapGetters } from "vuex";
import {
  formatToFileName,
  requireDepartmentPNGIcon,
  requireDepartmentPNGIconSrcset,
  truncate,
} from "@/util.js";
import Title from "@/components/UI/Title.vue";
import Icon from "@/components/UI/Icon.vue";

const end = { xs: 4, smAndUp: 7 };
const height = { xs: 150, smAndUp: 217 };

export default {
  name: "DepartmentsView",
  components: { Icon, Title },
  computed: {
    ...mapGetters("departments", {
      getDepartmentDisplayName: "getDepartmentDisplayName",
      getDepartmentSrc: "getDepartmentSrc",
    }),
    ...mapState({
      departments: (state) => state.departments.data,
    }),
    fixedListHeight() {
      return this.$vuetify.breakpoint.xsOnly ? height.xs : height.smAndUp;
    },
  },
  methods: {
    formatToFileName,
    requireDepartmentPNGIcon,
    requireDepartmentPNGIconSrcset,
    routeToCategory(department, category) {
      const { category_id: departmentId, sub_categories: categories } =
        department;
      const departmentRouteWithoutCategories = `/department/${departmentId}/category/${departmentId}`;

      return categories
        ? departmentId === "Menu"
          ? {
              name: "menu",
              hash: `#${slug(category.name.replace(/^\d/, "abc$&"))}`,
            }
          : {
              name: "category",
              params: {
                categoryName: category.name,
                categoryId: category.category_id,
                departmentId: department.category_id,
              },
            }
        : departmentRouteWithoutCategories;
    },
    routeToDepartment({
      category_id: departmentId,
      sub_categories: categories,
    }) {
      const departmentRoute = `/department/${departmentId}`;
      const departmentRouteWithoutCategories = `/department/${departmentId}/category/${departmentId}`;
      const menuRoute = "menu";

      return categories
        ? departmentId === "Menu"
          ? menuRoute
          : departmentRoute
        : departmentRouteWithoutCategories;
    },
    sliceDepartmentCategories(categories) {
      return this.$vuetify.breakpoint.xsOnly
        ? categories.slice(0, end.xs)
        : categories.slice(0, end.smAndUp);
    },
    truncate,
  },
};
</script>
<style scoped>
.department-image-size {
  object-fit: contain;
  height: 140px;
  width: 140px;
}
@media (min-width: 960px) {
  .department-image-size {
    height: 120px;
    width: 120px;
  }
}
@media (min-width: 1264px) {
  .department-image-size {
    height: 120px;
    width: 120px;
  }
}
@media (min-width: 1904px) {
  .department-image-size {
    height: 120px;
    width: 120px;
  }
}

.department-image-position {
  position: absolute;
  top: -12px;
  right: 0px;
}

.department-name {
  max-width: 175px;
  min-height: 56px;
  margin-top: 4px;
  white-space: break-spaces;
}

.overflow-hidden {
  overflow: hidden;
}
</style>
